document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".faq-question").forEach(function (button) {

    button.addEventListener("click", function () {

      const item = this.parentElement;

      item.classList.toggle("active");

    });

  });

});